






















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class Box extends Vue {
  show = true
  style = ''
  collapseIcon = 'fa-minus'

  @Prop({ type: Boolean, default: false }) collapsible!: boolean
  @Prop({ type: Boolean, default: false }) collapsed!: boolean

  get hasHeader (): boolean {
    return !!this.$slots.header
  }

  get hasFooter (): boolean {
    return !!this.$slots.footer
  }

  get hasBody (): boolean {
    return !!this.$slots.body
  }

  mounted () {
    if (this.collapsed) {
      this.style = 'display: none;'
      this.collapseIcon = 'fa-plus'
    }
    const cardRef = this.$refs.card
    if (cardRef) {
      const element: any = $(cardRef)
      element.CardWidget({ collapseIcon: 'fa-chevron-right', expandIcon: 'fa-chevron-down' })
    }
  }
}
